var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home pt-3"},[_c('transition',{attrs:{"name":"animate-route","mode":"out-in","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('article-list',{attrs:{"articles":_vm.articles}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }